export default "__VITE_ASSET__Cyk0v3w___"